"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var main_1 = require("../../main");
var Badge_1 = __importDefault(require("../Badge/Badge"));
var BadgedIcon = /** @class */ (function (_super) {
    __extends(BadgedIcon, _super);
    function BadgedIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BadgedIcon.prototype.render = function () {
        var _a = this.props, badge = _a.badge, color = _a.color, iconColor = _a.iconColor, content = _a.content, empty = _a.empty, className = _a.className, name = _a.name, root = _a.root, size = _a.size, rest = __rest(_a, ["badge", "color", "iconColor", "content", "empty", "className", "name", "root", "size"]);
        var badgeProps = {
            color: color,
            content: badge,
            empty: !badge
        };
        return (React.createElement("div", __assign({}, rest, { className: 'badged-icon ' + (className || '') }),
            React.createElement(main_1.Icon, __assign({}, rest, { size: size, name: name, root: root, color: iconColor })),
            React.createElement(Badge_1.default, __assign({}, badgeProps))));
    };
    BadgedIcon.defaultProps = {
        color: 'grey',
        root: 'common'
    };
    return BadgedIcon;
}(React.Component));
exports.default = BadgedIcon;
